const translations: Record<string, string> = {
  "nav.home": "Strona Główna",
  "nav.categories": "Kategorie",
  "nav.guides": "Poradniki",
  "nav.contact": "Kontakt",

  "category.shoes": "Buty",
  "category.hoodies": "Bluzy/Swetry",
  "category.tshirts": "T-Shirty",
  "category.jackets": "Kurtki",
  "category.pants": "Spodnie/Szorty",
  "category.headwear": "Nakrycia Głowy",
  "category.sets": "Zestawy",
  "category.underwear": "Bielizna",
  "category.jersey": "Koszulki Sportowe",
  "category.accessories": "Akcesoria",
  "category.bags": "Torby",
  "category.belts": "Paski",
  "category.perfumes": "Perfumy",
  "category.other": "Inne",

  "hero.title": "Największy Kakobuy Spreadsheet w Polsce",
  "hero.subtitle": "Ponad 10 000 sprawdzonych produktów, zdjęcia QC, przewodniki zakupowe, najlepsze oferty i aktualizowany codziennie Kakobuy Spreadsheet.",
  "hero.cta.spreadsheet": "kakobuy sheet",
  "hero.cta.products": "Zobacz Najnowsze Produkty",
  "hero.tag": "Arkusz Produktów Premium",

  "trust.verified": "Zweryfikowane produkty",
  "trust.qc": "Zdjęcia QC",
  "trust.guides": "Poradniki zakupowe",
  "trust.safe": "Bezpieczne zakupy",
  "trust.daily": "Aktualizowany codziennie",
  "trust.title": "Twój Zaufany Przewodnik po Świecie Kakobuy",
  "trust.description": "Nasz arkusz Kakobuy to nie tylko lista produktów — to kompletny system wyszukiwania najlepszych okazji. Każdy produkt został ręcznie zweryfikowany, posiada zdjęcia kontroli jakości i szczegółowe informacje, które pomogą Ci podjąć najlepszą decyzję zakupową.",
  "trust.stats.number": "10 000+",
  "trust.stats.label": "sprawdzonych produktów w naszym arkuszu",
  "trust.cta": "buy it now",

  "categories.title": "Kategorie Produktów",
  "categories.subtitle": "Przeglądaj nasze najpopularniejsze kategorie",

  "featured.title": "Popularne Kategorie",
  "featured.subtitle": "Odkryj najczęściej wybierane produkty",

  "testimonials.title": "Co Mówią Nasi Użytkownicy",
  "testimonials.subtitle": "Opinie osób korzystających z naszego arkusza",

  "article.cta.title": "Poradniki Kakobuy Sheet",
  "article.cta.subtitle": "Dowiedz się jak najlepiej wykorzystać nasz arkusz i znaleźć najlepsze produkty",
  "article.cta.button": "Przeczytaj Poradnik",
  "article.cta.products": "Przeglądaj Produkty",

  "footer.brand": "Kakobuy Spreadsheet",
  "footer.tagline": "Najlepszy arkusz produktów w Polsce",
  "footer.newsletter": "Zapisz się do newslettera",
  "footer.newsletter.placeholder": "Twój adres email",
  "footer.newsletter.success": "Dziękujemy za zapisanie się!",
  "footer.newsletter.error.empty": "Proszę wpisać adres email.",
  "footer.newsletter.error.general": "Wystąpił błąd. Spróbuj ponownie później.",
  "footer.subscribe": "Subskrybuj",
  "footer.promo": "Otrzymuj najlepsze oferty i nowości",
  "footer.copyright": "Wszelkie prawa zastrzeżone.",
  "footer.privacy": "Polityka prywatności",
  "footer.quick.links": "Szybkie Linki",
  "footer.categories": "Kategorie",
  "footer.guides": "Poradniki",
  "footer.contact": "Kontakt",

  "article.back": "Wróć do Strony Głównej",
  "article.tag": "Poradnik SEO",
  "article.title": "Kompletny Przewodnik po Kakobuy Spreadsheet",
  "article.category": "Poradniki",

  "testimonial.1.name": "Anna Kowalska",
  "testimonial.1.text": "Ten arkusz Kakobuy zmienił moje podejście do zakupów online. Wszystko jest w jednym miejscu, a zdjęcia QC dają mi pewność, że kupuję dokładnie to, czego oczekuję.",
  "testimonial.2.name": "Piotr Nowak",
  "testimonial.2.text": "Korzystam z arkusza Kakobuy od ponad roku i zaoszczędziłem mnóstwo czasu. Kategorie są świetnie zorganizowane, a produkty zawsze aktualne.",
  "testimonial.3.name": "Marta Wiśniewska",
  "testimonial.3.text": "Najlepsze źródło informacji o produktach Kakobuy. Poradniki są niezwykle pomocne, a lista produktów jest regularnie aktualizowana.",
  "testimonial.4.name": "Krzysztof Zieliński",
  "testimonial.4.text": "Polecam każdemu, kto szuka sprawdzonych produktów w dobrych cenach. Arkusz Kakobuy to must-have dla świadomych kupujących.",
  "testimonial.5.name": "Karolina Mazur",
  "testimonial.5.text": "Dzięki temu arkuszowi Kakobuy odkryłam produkty, których normalnie bym nie znalazła. System kategorii i wyszukiwania działa rewelacyjnie.",
};

export default translations;